// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import labelsObj from '@tcp/core/src/components/features/account/Payment/Payment.labels';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import Heading from '../../../../common/atoms/Heading';
import EmptyCard from '../../common/molecule/EmptyCard/views/EmptyCard.view';
import Button from '../../../../common/atoms/Button';
import withStyles from '../../../../common/hoc/withStyles';
import styles from '../styles/CardList.style';
import Col from '../../../../common/atoms/Col';
import Row from '../../../../common/atoms/Row';
import { CardView } from './Card.view';

const CreditCardList = ({
  creditCardList,
  className,
  setDefaultPaymentMethod,
  setDeleteModalMountState,
  deleteModalMountedState,
  onDeleteCard,
  showUpdatedNotificationOnModal,
  showNotification,
  setSelectedCard,
  addCreditCard,
  editCreditCard,
}) => {
  const gcLabels =
    getLabelFromCopyOrFromTranslation('account.paymentGC', labelsObj) ||
    labelsObj.account.paymentGC;

  const clickEventdata = {
    customEvents: [],
    eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.payment_addNewCard,
    pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.payment_addNewCard,
  };

  return (
    <div className={className}>
      <Heading
        variant="h6"
        className="cardList__heading"
        dataLocator="payment-creditAndDebitCardsLabel"
      >
        {renderLabel(gcLabels.lbl_payment_ccHeading, 'lbl_payment_ccHeading')}
      </Heading>
      {creditCardList.size === 0 && <EmptyCard icon="credit_card" alt="card icon" prefix="CC" />}
      <Row fullBleed>
        <Col
          colSize={{
            large: 4,
            medium: 4,
            small: 6,
          }}
          className={`${creditCardList.size !== 0 ? 'payment__addBtn__cont' : ''}`}
        >
          <ClickTracker clickData={clickEventdata}>
            <Button
              buttonVariation="fixed-width"
              fill="BLUE"
              className="cardList__ccAddCta"
              dataLocator="payment-addcreditcard"
              onClick={addCreditCard}
            >
              {creditCardList.size === 0
                ? renderLabel(gcLabels.lbl_payment_ccEmptyAddBtn, 'lbl_payment_ccEmptyAddBtn')
                : renderLabel(gcLabels.lbl_payment_addBtn, 'lbl_payment_addBtn')}
            </Button>
          </ClickTracker>
        </Col>
      </Row>
      {creditCardList.size !== 0 && (
        <CardView
          deleteModalMountedState={deleteModalMountedState}
          setDeleteModalMountState={setDeleteModalMountState}
          onDeleteCard={onDeleteCard}
          showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
          setDefaultPaymentMethod={setDefaultPaymentMethod}
          cardList={creditCardList}
          showNotification={showNotification}
          setSelectedCard={setSelectedCard}
          editCreditCard={editCreditCard}
        />
      )}
    </div>
  );
};

CreditCardList.defaultProps = {
  deleteModalMountedState: false,
  addCreditCard: null,
  editCreditCard: null,
};

CreditCardList.propTypes = {
  creditCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string.isRequired,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  setDeleteModalMountState: PropTypes.func.isRequired,
  deleteModalMountedState: PropTypes.bool,
  onDeleteCard: PropTypes.func.isRequired,
  showUpdatedNotificationOnModal: PropTypes.string.isRequired,
  showNotification: PropTypes.bool.isRequired,
  setSelectedCard: PropTypes.string.isRequired,
  addCreditCard: PropTypes.func,
  editCreditCard: PropTypes.func,
};
export default withStyles(CreditCardList, styles);
export { CreditCardList as CreditCardListVanilla };
